import axios from "axios";

export async function resetPassword(email, reset_token, new_password) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/resetPassword`,
      {
        reset_token,
        email,
        new_password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      },
    );

    if (response.data.success === true) {
      return response.data.message;
    } else {
      return response.data.message;
    }
  } catch (error) {
    return null;
  }
}

// Function to verify reset token
export async function verifyResetToken(email, reset_token) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/verifyResetToken`,
      {
        email,
        reset_token,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      },
    );

    if (response.data.success === true) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    return null;
  }
}

// Function to initiate password reset
export async function initiatePasswordReset(email) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/initiatePasswordReset`,
    {
      email,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
    },
  );

  if (response.data.success === true) {
    return response.data;
  } else {
    return response.data;
  }
}
